import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '@/utils/cn';
import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import * as React from 'react';
const bodySmall = 'text-xs leading-[130%]';
const bodyVariants = cva('tracking-tight [&_a]:underline [&_a]font-bold transition-palette-animate', {
    variants: {
        variant: {
            large: 'text-xl md:text-2xl leading-[135%]',
            medium: 'text-base md:text-lg leading-[150%]',
            small: bodySmall,
            caption: bodySmall,
        },
    },
    defaultVariants: {
        variant: 'caption',
    },
});
export const BodyLarge = React.forwardRef(({ variant = 'large', className, asChild, ...props }, forwardedRef) => {
    const Comp = asChild ? Slot : 'div';
    return _jsx(Comp, { ref: forwardedRef, className: cn(bodyVariants({ variant, className })), ...props });
});
export const BodyMedium = React.forwardRef(({ variant = 'medium', className, asChild, ...props }, forwardedRef) => {
    const Comp = asChild ? Slot : 'div';
    return _jsx(Comp, { ref: forwardedRef, className: cn(bodyVariants({ variant, className })), ...props });
});
export const BodySmall = React.forwardRef(({ variant = 'small', className, asChild, ...props }, forwardedRef) => {
    const Comp = asChild ? Slot : 'small';
    return _jsx(Comp, { ref: forwardedRef, className: cn(bodyVariants({ variant, className })), ...props });
});
export const Caption = React.forwardRef(({ variant = 'small', className, asChild, ...props }, forwardedRef) => {
    const Comp = asChild ? Slot : 'small';
    return _jsx(Comp, { ref: forwardedRef, className: cn(bodyVariants({ variant, className })), ...props });
});
